import { gql } from '../../../artifacts/gql';

export const updateUserPhone = gql(`
  mutation webUpdateUserPhoneMutation($phone: String!) {
    collectUpdateUserPhone(phone: $phone) {
      successful
      messages {
        message
        code
      }
    }
  }
`);
